// Perf datapoints for Mail Reading Pane load
export const MAIL_READING_PANE_LOAD_START = 'MailReadingPaneLoadStart';
export const MAIL_READING_PANE_LOAD_END = 'MailReadingPaneLoadEnd';

// Perf datapoints for loading Reading Pane on page refresh
export const MAIL_LOAD_READING_PANE_ON_REFRESH_START = 'MailLoadReadingPaneOnRefreshStart';

// Perf datapoints for compose email
export const COMPOSE_MAIL_CLICKED = 'ComposeEmailClicked';
export const HARD_BACK_BUTTON_CLICKED = 'HardBackButton';

// Perf datapoints for load more emails
export const LOAD_MORE_MAIL_STARTED = 'LoadMoreEmailStart';
export const LOAD_MORE_MAIL_ENDED = 'LoadMoreEmailEnd';

// Perf datapoints for switch folders
export const FOLDER_CLICKED = 'MailFolderClicked';
export const FOLDER_MAILS_LOADED = 'FolderMailsLoaded';
export const FOCUSED_OTHER_TAB_CLICKED = 'FocusedOtherTabClicked';
export const FOLDER_CHANGED = 'FolderChanged';

// Perf datapoint names for filter actions
export const FILTER_SELECTED = 'FilterSelected';
export const FILTER_BUTTON_CLICKED = 'FilterButtonClicked';
export const FILTER_OVERLAY_CLICKED = 'FilterOverlayClicked';

// Perf datapoint names for swipe actions
export const SWIPE_ACTION_BEGIN = 'SwipeBegin';

// Perf datapoint names for multiselect view
export const DELETE_SELECTED_MAIL_ITEMS_BEGIN = 'DeleteSelectedMailsBegin';
export const DELETE_SELECTED_CONVERSATIONS_BEGIN = 'DeleteSelectedConversationsBegin';

// Datapoint names for list view actions
export const MAIL_LIST_SCROLLED_3_TIMES = 'MAIL_LIST_SCROLLED_3_TIMES';
